import {
    Box, Flex,
    Heading, HStack, Input, Radio, RadioGroup, Stack,
    Text, Textarea, useBoolean, useBreakpointValue,
    useDisclosure,
    VStack
} from "@chakra-ui/react";
import {CustomCheckbox, InputLabel, PaginationRow, StyledButton} from "../../../components";
import React, {useState} from "react";
import {ReactComponent as Close} from "../../../assets/icons/CloseButton.svg";
import {ReactComponent as Delete} from "../../../assets/icons/profile/delete_icon.svg";
import {ReactComponent as Edit} from "../../../assets/icons/profile/edit.svg";
import {ReactComponent as Back} from "../../../assets/icons/back.svg";
import {Screener} from "../../../helpers/data-jsons";
import {CustomSelectExchanges} from "../../../components/theme/select/CustomSelectExchanges";

const AddTemplate = ({setActiveTab}) => {
    const isMobile = useBreakpointValue({base: true, md: false, lg: false})
    const [value, setValue] = useState('buy_and_sell');
    const [notType, setNotType] = useState('1');
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(2);
    return (
        <VStack
            color={'neutral.100'}
            w={'100%'}>
            <Box
                w={'full'}
                p={{base: '16px'}}
                bg={'neutral.1100'}
                borderRadius={{base: '0', md: '16px'}}
                display={'flex'}
                flexDirection={'column'}
                gap={'24px'}
            >
                <Flex
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    p={{base: '16px 10px', md: '11px 0'}}
                    w={'100%'}
                >
                    <Flex alignItems={'center'}
                          justifyContent={'space-between'}
                          w={'100%'}
                    >
                        <Heading
                            display={'flex'}
                            alignItems={'center'}
                            color={'neutral.100'}
                            gap={'4px'}
                            fontSize={'heading.3xl'}>
                            <Box
                                cursor={'pointer'}
                                onClick={() => setActiveTab('templates')}
                            >
                                <Back/></Box><span>Screener template</span>
                        </Heading>
                        <Box
                            cursor={'pointer'}
                            onClick={() => setActiveTab('templates')}
                        ><Close/></Box>
                    </Flex>
                </Flex>
                <HStack>
                    <Box
                        w={'full'}
                        display={'flex'}
                        flexWrap={'wrap'}
                        flexDirection={'column'}
                        gap={'12px'}
                        justifyContent={'space-between'}
                        maxW={'530px'}
                    >
                        <Text color={'neutral.600'}>Template name</Text>
                        <Input
                            minH={'40px'}
                            border={'none'}
                            borderRadius={'8px'}
                            bg={'neutral.900'}
                            type={'text'}
                            label={'Name'}
                            maxW={'565px'}/>
                    </Box>
                </HStack>
                <Heading
                    fontWeight={'500'}
                    fontSize={'18px'}
                >Exchange Selection Mode</Heading>
                <RadioGroup value={value} onChange={setValue}>
                    <Stack direction={{base: 'column', sm: 'row'}} spacing="24px">
                        <Radio
                            value="all"
                            colorScheme="purple"
                            size="lg"
                            border={'solid 2px #353945'}
                            // bg={'transparent'}
                            // _checked={{bg: 'unset',color:'#5834A8'}}
                        >
                            <Text fontSize={'16px'} color={'neutral.500'}>Choose together</Text>
                        </Radio>
                        <Radio
                            value="buy_and_sell"
                            colorScheme="purple"
                            size="lg"
                            border={'solid 2px #353945'}
                        >
                            <Text fontSize={'16px'} color={'neutral.500'}>Choose buy and sell separately</Text>
                        </Radio>
                    </Stack>
                </RadioGroup>
                <Flex
                    flexDirection={{base: 'column', md: 'row'}}
                    justifyContent={'space-between'}
                    gap={'16px'}
                >
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Tracked exchanges</Text>
                        <CustomSelectExchanges
                            width={'100%'}
                            placeholder={'Choose'}
                        />
                    </Flex>
                    {value === 'buy_and_sell' && <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Selling Exchange</Text>
                        <CustomSelectExchanges
                            width={'100%'}
                            placeholder={'Choose'}
                        />
                    </Flex>}
                </Flex>
                <Flex
                    flexDirection={{base: 'column', md: 'row'}}
                    justifyContent={'space-between'}
                    gap={'16px'}
                >
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Whitelist of currencies</Text>
                        <Textarea
                            w={'full'}
                            placeholder={'Text'}
                            bg={'neutral.900'}
                            color={'#fff'}
                            outline={'0'}
                            border={'solid 1px #23262F'}
                            borderColor={'#23262F!important'}
                            boxShadow={'unset!important'}
                            _hover={{
                                border: 'solid 1px#23262F',
                            }}
                        ></Textarea>
                    </Flex>
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Blacklists of caurrencies</Text>
                        <Textarea
                            w={'full'}
                            placeholder={'Text'}
                            bg={'neutral.900'}
                            color={'#fff'}
                            outline={'0'}
                            border={'solid 1px #23262F'}
                            borderColor={'#23262F!important'}
                            boxShadow={'unset!important'}
                            _hover={{
                                border: 'solid 1px#23262F',
                            }}
                        ></Textarea>
                    </Flex>

                </Flex>
                <Flex
                    flexDirection={{base: 'column', md: 'row'}}
                    justifyContent={'space-between'}
                    gap={'16px'}
                >
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Networks for withdrawal</Text>
                        <CustomSelectExchanges
                            width={'100%'}
                            placeholder={'Choose'}
                        />
                    </Flex>
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Networks for deposit</Text>
                        <CustomSelectExchanges
                            width={'100%'}
                            placeholder={'Choose'}
                        />
                    </Flex>

                </Flex>
                <Flex
                    flexDirection={{base: 'column', md: 'row'}}
                    justifyContent={'space-between'}
                    gap={'16px'}
                >
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Withdrawal network status</Text>
                        <CustomSelectExchanges
                            width={'100%'}
                            placeholder={'Choose'}
                        />
                    </Flex>
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Deposit network status</Text>
                        <CustomSelectExchanges
                            width={'100%'}
                            placeholder={'Choose'}
                        />
                    </Flex>

                </Flex>
                <Flex
                    gap={'8px'}
                >
                    <CustomCheckbox
                        border={'6px'}
                    />
                    <Text color={'neutral.100'}>Network Compatibility</Text>
                </Flex>
                <Flex
                    flexDirection={{base: 'column', md: 'row'}}
                    justifyContent={'space-between'}
                    gap={'16px'}
                >
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Min lifetime, sec</Text>
                        <InputLabel
                            type={'number'}
                            w={'full'}
                            bg={'transparent'}
                            height={isMobile ? '40px' : '40px'}
                        />
                    </Flex>
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Max lifetime, sec</Text>
                        <InputLabel
                            type={'number'}
                            w={'full'}
                            bg={'transparent'}
                            height={isMobile ? '40px' : '40px'}
                        />
                    </Flex>
                </Flex>
                <Flex
                    flexDirection={{base: 'column', md: 'row'}}
                    justifyContent={'space-between'}
                    gap={'16px'}
                >
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Min profit, %</Text>
                        <InputLabel
                            type={'number'}
                            w={'full'}
                            bg={'transparent'}
                            height={isMobile ? '40px' : '40px'}
                        />
                    </Flex>
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Min profit, %</Text>
                        <InputLabel
                            type={'number'}
                            w={'full'}
                            bg={'transparent'}
                            height={isMobile ? '40px' : '40px'}
                        />
                    </Flex>
                </Flex>
                <Flex
                    flexDirection={{base: 'column', md: 'row'}}
                    justifyContent={'space-between'}
                    gap={'16px'}
                >
                    <Flex
                        w={{base: '100%', md: '45%', cs: '518px'}}
                        flexDirection={'column'}
                        gap={'8px'}
                    >
                        <Text color={'neutral.600'}>Min transaction amount, $</Text>
                        <InputLabel
                            type={'number'}
                            w={'full'}
                            bg={'transparent'}
                            height={isMobile ? '40px' : '40px'}
                        />
                    </Flex>
                </Flex>
                <HStack>
                    <Box
                        w={'full'}
                        display={'flex'}
                        flexDirection={'row'}
                        justifyContent={'end'}
                        gap={'24px'}
                    >
                        <StyledButton maxHeight={'40px'} fontSize={'16px'} bg={'#6F41D240'}>Delete</StyledButton>
                        <StyledButton maxHeight={'40px'} fontSize={'16px'} bg={'#5834A8'}>Save</StyledButton>
                    </Box>
                </HStack>
            </Box>

        </VStack>


    )
}
export default AddTemplate